import { useDispatch } from 'react-redux';
import { CreateEntityModal } from './Components/CreateEntityModal';
import { EntitiesTable } from './Components/MyEntitiesTable';
import { ZorbaButton } from '../../../../components/forms';
import { BUTTON_VARIANT_DARK } from '../../../../components/forms/ZorbaButton/constants';
import { MODAL_CREATE_ENTITY } from '../../../../reducers/Modal/types';
import { setModalState } from '../../../../reducers/Modal/actions';

import './index.scss';

export const MyEntities = () => {
  const dispatch = useDispatch();
  const handleOpenModal = () => {
    dispatch(setModalState(MODAL_CREATE_ENTITY, true));
  };

  return (
    <>
      <div className="button-container">
        <ZorbaButton
          variant={BUTTON_VARIANT_DARK}
          onClick={handleOpenModal}
          fullWidth={false}
        >
          + Add entity
        </ZorbaButton>
      </div>
      <EntitiesTable />
      <CreateEntityModal />
    </>
  );
};
